import { FolderCardSize, folderCardSizeBreakpoints } from './consts';
import styleVars from './vars.scss';
export const getFolderCardSizeBasedOnWidth = (width)=>{
    if (width <= folderCardSizeBreakpoints[FolderCardSize.NANO]) {
        return FolderCardSize.NANO;
    }
    if (width <= folderCardSizeBreakpoints[FolderCardSize.TINY]) {
        return FolderCardSize.TINY;
    }
    if (width <= folderCardSizeBreakpoints[FolderCardSize.MEDIUM]) {
        return FolderCardSize.SMALL;
    }
    if (width >= folderCardSizeBreakpoints[FolderCardSize.BIG]) {
        return FolderCardSize.BIG;
    }
    return FolderCardSize.MEDIUM;
};
export const getPadding = (size, isMobile)=>{
    if (isMobile) {
        return 2 * parseInt(styleVars['mobile-padding'], 10);
    }
    if (size === FolderCardSize.NANO) {
        return 2 * parseInt(styleVars['nano-padding'], 10);
    }
    if (size === FolderCardSize.BIG) {
        return 2 * parseInt(styleVars['big-padding'], 10);
    }
    return 2 * parseInt(styleVars['normal-padding'], 10);
};
